import { render } from "./ButtonIconBids.vue?vue&type=template&id=078a2cf9&scoped=true"
import script from "./ButtonIconBids.vue?vue&type=script&lang=js"
export * from "./ButtonIconBids.vue?vue&type=script&lang=js"

import "./ButtonIconBids.vue?vue&type=style&index=0&id=078a2cf9&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078a2cf9"]])

export default __exports__